import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import axios from 'axios';

const OAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      if (window.oauthCallbackProcessed) {
        return;
      }
      window.oauthCallbackProcessed = true;

      const code = searchParams.get('code');
      const error = searchParams.get('error');

      if (error) {
        console.error('OAuth error:', error);
        const isUserSubmission = sessionStorage.getItem('userSubmission');
        if (isUserSubmission) {
          navigate('/login', { state: { error: 'OAuth authorization failed' } });
        } else {
          navigate('/', { state: { error: 'OAuth authorization failed' } });
        }
        sessionStorage.removeItem('userSubmission');
        return;
      }

      if (code) {
        try {
          const isUserSubmission = sessionStorage.getItem('userSubmission');
          const token = localStorage.getItem('token');

          console.log('Processing OAuth code...');
          await axios.post('http://localhost:5000/api/tokens/oauth',
            { code },
            {
              headers: token ? { Authorization: `Bearer ${token}` } : {},
            }
          );

          console.log('Token processed successfully');
          if (isUserSubmission) {
            navigate('/login', { state: { success: 'Token submitted successfully! Thank you for your contribution.' } });
          } else {
            navigate('/', { state: { success: 'Token added successfully' } });
          }

          sessionStorage.removeItem('userSubmission');
        } catch (error) {
          console.error('Token addition error:', error);
          const isUserSubmission = sessionStorage.getItem('userSubmission');
          if (isUserSubmission) {
            navigate('/login', { state: { error: error.response?.data?.message || 'Failed to submit token. Please try again.' } });
          } else {
            navigate('/', { state: { error: 'Failed to add token' } });
          }
          sessionStorage.removeItem('userSubmission');
        }
      } else {
        const isUserSubmission = sessionStorage.getItem('userSubmission');
        if (isUserSubmission) {
          navigate('/login', { state: { error: 'No authorization code received' } });
        } else {
          navigate('/', { state: { error: 'No authorization code received' } });
        }
        sessionStorage.removeItem('userSubmission');
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 2 }}>
        Processing OAuth callback...
      </Typography>
    </Box>
  );
};

export default OAuthCallback;